import Vue from 'vue';
import VModal from 'vue-js-modal';
import {API_URL, DEFAULT_LANG_UUID} from '../utils/consts';
import i18n from '../plugins/i18n';
import moment from 'moment'
import '../utils/event'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import {injectTokenInterceptor} from "../utils/tokenInterceptor";
import { SiteToasts } from '../utils/toast';
import dateFilter from '../utils/dateFilter'
import money from 'v-money';
import {VueMaskFilter} from 'v-mask'
import {VueMaskDirective} from 'v-mask'

moment.locale('cs')

  if (!window.VModalRegistered) {
      Vue.use(VModal, { dynamic: true })
      window.VModalRegistered = true
  };
Vue.use(money)
Vue.use(SiteToasts)
Vue.component('v-select', vSelect)

Vue.filter('lang', (value) => {
    return value[DEFAULT_LANG_UUID]
})

Vue.filter('formatDate', dateFilter)
Vue.filter('VMask', VueMaskFilter)

const FilePond = vueFilePond()
Vue.component('file-pond', FilePond)

Vue.directive('mask', VueMaskDirective)

import VueForm from 'vue-form'
import {validateEmail} from "../Registration/validators/emailValidator"
import {validateTelephone} from "../Registration/validators/telephoneValidator"

Vue.use(VueForm, {
    validators: {
        email: value => validateEmail(value),
        phone: value => validateTelephone(value),
    }
})

new Vue({
    i18n,
    el: '#myAccount',
    components: {
        'bid-button': () => import(/* webpackPrefetch: true */'../AuctionRoom/components/BidButton'),
        'bottom': () => import(/* webpackPrefetch: true */'./components/Bottom'),
        'content-section': () => import(/* webpackPrefetch: true */'./components/Content'),
        'master-head': () => import(/* webpackPrefetch: true */'./components/MasterHead'),
    },

    data() {
        return {}
    },

    created() {
        injectTokenInterceptor(this.$toasted)
        const translateEl = document.getElementById('translates-myaccount')
        this.$i18n.setLocaleMessage('cs', JSON.parse(translateEl.innerHTML))
    },
    methods: {}
});
